document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const ready = (callback) => {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
  else callback();
};

ready(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menuButton.setAttribute('aria-expanded', 'false');
      mobileMenu.hidden = true;
      document.body.classList.remove('menu-open');
    }));
  }

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    const buttons = control.querySelectorAll('button');
    if (!input || buttons.length < 2) return;
    const setQuantity = (value) => {
      input.value = Math.max(1, Number(value || 1));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    buttons[0].addEventListener('click', () => setQuantity(Number(input.value || 1) - 1));
    buttons[1].addEventListener('click', () => setQuantity(Number(input.value || 1) + 1));
  });

  const currency = window.Shopify?.currency?.active || 'USD';
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency
  }).format(Number(cents || 0) / 100);

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    if (!form) return;
    const price = root.querySelector('[data-price]');
    const compare = root.querySelector('[data-compare-price]');
    const variantIdInput = form.querySelector('[data-variant-id-input]');
    const savingsBadge = root.querySelector('[data-savings-badge]');
    const priceBadge = root.querySelector('[data-price-badge]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    form.querySelectorAll('input[data-variant-selector][type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (variantIdInput) {
          variantIdInput.value = radio.value;
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        form.querySelectorAll('.variant-card').forEach((card) => card.classList.remove('is-selected'));
        form.querySelectorAll('.reference-bundle').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('.variant-card')?.classList.add('is-selected');
        radio.closest('.reference-bundle')?.classList.add('is-selected');
        if (price) price.textContent = formatMoney(radio.dataset.priceCents);
        if (stickyPrice) stickyPrice.textContent = formatMoney(radio.dataset.priceCents);
        if (compare) {
          const compareCents = Number(radio.dataset.compareCents || 0);
          const priceCents = Number(radio.dataset.priceCents || 0);
          compare.textContent = compareCents > priceCents ? formatMoney(compareCents) : '';
          compare.hidden = compareCents <= priceCents;
          const savings = compareCents > priceCents ? Math.round((compareCents - priceCents) * 100 / compareCents) : 0;
          [savingsBadge, priceBadge].forEach((badge) => {
            if (!badge) return;
            badge.textContent = savings > 0 ? `SAVE ${savings}%` : '';
            badge.hidden = savings <= 0;
            badge.classList.toggle('is-hidden', savings <= 0);
          });
        }
      });
    });
  });

  document.querySelectorAll('[data-reference-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || !thumbs.length) return;

    const viewport = gallery.querySelector('[data-gallery-viewport]');
    const track = gallery.querySelector('[data-gallery-track]');
    const swipeSurface = gallery.querySelector('[data-gallery-swipe]');
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const status = gallery.querySelector('[data-gallery-status]');
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    let swapToken = 0;

    const centerThumbnail = (thumb) => {
      const scroller = track || viewport;
      if (!scroller) return;
      const scrollerRect = scroller.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const relativeLeft = scroller.scrollLeft + (thumbRect.left - scrollerRect.left);
      const targetLeft = relativeLeft - ((scroller.clientWidth - thumbRect.width) / 2);
      const maximumLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      scroller.scrollTo({ left: Math.min(maximumLeft, Math.max(0, targetLeft)), behavior: 'smooth' });
    };

    const activate = (index, moveFocus = false, centerActiveThumbnail = true) => {
      const normalizedIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[normalizedIndex];
      const nextSource = thumb.dataset.galleryThumb;
      const nextAlt = thumb.dataset.galleryAlt || thumb.querySelector('img')?.alt || main.alt;
      if (!nextSource) return;

      activeIndex = normalizedIndex;
      thumbs.forEach((item, itemIndex) => {
        const selected = itemIndex === activeIndex;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });

      const token = ++swapToken;
      let completed = false;
      const finishSwap = () => {
        if (completed || token !== swapToken) return;
        completed = true;
        main.src = nextSource;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.alt = nextAlt;
        requestAnimationFrame(() => main.classList.remove('is-changing'));
      };
      main.classList.add('is-changing');
      const preload = new Image();
      preload.onload = finishSwap;
      preload.onerror = finishSwap;
      preload.src = nextSource;
      if (preload.complete) finishSwap();

      if (centerActiveThumbnail) centerThumbnail(thumb);
      if (moveFocus) thumb.focus({ preventScroll: true });
      if (status) status.textContent = `Image ${activeIndex + 1} of ${thumbs.length} selected: ${nextAlt}`;
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => activate(index, false, false));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') activate(0, true);
        else if (event.key === 'End') activate(thumbs.length - 1, true);
        else activate(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
    });
    previous?.addEventListener('click', () => activate(activeIndex - 1));
    next?.addEventListener('click', () => activate(activeIndex + 1));

    if (swipeSurface && thumbs.length > 1) {
      const isMobileGallery = () => window.matchMedia('(max-width: 749px)').matches;
      let trackingSwipe = false;
      let swipePointerId = null;
      let swipeStartX = 0;
      let swipeStartY = 0;

      const finishSwipe = (event, cancelled = false) => {
        if (!trackingSwipe || event.pointerId !== swipePointerId) return;
        const distanceX = event.clientX - swipeStartX;
        const distanceY = event.clientY - swipeStartY;
        trackingSwipe = false;
        swipePointerId = null;
        swipeSurface.classList.remove('is-swiping');
        if (swipeSurface.hasPointerCapture?.(event.pointerId)) swipeSurface.releasePointerCapture(event.pointerId);
        if (cancelled || !isMobileGallery()) return;
        const isIntentionalHorizontalSwipe = Math.abs(distanceX) >= 42 && Math.abs(distanceX) > Math.abs(distanceY) * 1.15;
        if (isIntentionalHorizontalSwipe) activate(activeIndex + (distanceX < 0 ? 1 : -1));
      };

      swipeSurface.addEventListener('pointerdown', (event) => {
        if (!isMobileGallery() || event.pointerType === 'mouse' || !event.isPrimary) return;
        trackingSwipe = true;
        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        swipeSurface.classList.add('is-swiping');
        swipeSurface.setPointerCapture?.(event.pointerId);
      }, { passive: true });
      swipeSurface.addEventListener('pointerup', (event) => finishSwipe(event));
      swipeSurface.addEventListener('pointercancel', (event) => finishSwipe(event, true));
      swipeSurface.addEventListener('lostpointercapture', () => {
        trackingSwipe = false;
        swipePointerId = null;
        swipeSurface.classList.remove('is-swiping');
      });
    }

    if (thumbs.length < 2) {
      if (previous) previous.hidden = true;
      if (next) next.hidden = true;
    }
  });

  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: .08 });
    reveals.forEach((item) => revealObserver.observe(item));
  } else reveals.forEach((item) => item.classList.add('is-revealed'));

  const stickyBuy = document.querySelector('[data-sticky-buy]');
  if (stickyBuy) {
    const updateSticky = () => stickyBuy.classList.toggle('is-visible', window.scrollY > 720);
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
  }
});
